import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { plans } from "../../store/plans/actions";
export var useGetPlansAllV2 = function (trigger, planIds, projectId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responsePlans: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responsePlans = _d.responsePlans, errorPlans = _d.errorPlans, loadingPlans = _d.loadingPlans;
    useEffect(function () {
        // Only trigger the API call if projectId is available
        if (trigger && projectId) {
            dispatch(plans({
                enable: enable,
                page: page,
                limit: limit,
                planId: planIds,
                projectId: projectId,
            }));
        }
    }, [enable, page, limit, trigger, planIds, projectId]);
    return {
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
